// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pUKm8","absolute":"styles_absolute__yFmtm"};